$(document).ready(function() {
  if ($('.pageLabel-accountRegisterPage').length > 0) {
    $('#ph-phoneNumber, #ph-commnumber').keypress(function(event) {
      // If the letter is not digit then display error and don't type anything
      if (event.which !== 8 && event.which !== 0 && (event.which < 48 || event.which > 57)) {
        return false;
      }

      return true;
    });

    $(document).on('blur', '#emailAddress', function() {
      var emailInputId = $(this).attr('id');
      var emailValue = $('#emailAddress input').val();

      ACC.registerPage.isEmptyValue(emailInputId);

      if (ACC.validation.email(emailValue)) {
        $('#emailAddress').find('.ph-signup__error').addClass(ACC.registerPage.errorClass);
        $('#emailAddress').find('.ph-register__emptyvalue').text($('#emailAddress').attr('data-emptyContent'));
      }
    });

    $(document).on('blur', '#ph-firstName', function() {
      var firstnameInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(firstnameInputId);
    });

    $(document).on('blur', '#ph-lastName', function() {
      var lastnameInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(lastnameInputId);
    });

    $(document).on('blur', '#ph-phoneNumber', function() {
      var phonenumberInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(phonenumberInputId);
    });

    $(document).on('blur', '#ph-commnumber', function() {
      ACC.registerPage.validateAccountNumber();
    });

    $(document).on('blur', '#ph-companyName', function() {
      var companyNameInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(companyNameInputId);
    });

    $(document).on('blur', '#ph-postalCode', function() {
      var postalcodeInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(postalcodeInputId);
    });
  }

  // eslint-disable-next-line require-jsdoc
  function validateResetEmailAddress() {
    var emailInpout = '.ph-username',
        emailValue = $('.ph-username').val();

    $('.ph-email_error').addClass(ACC.registerPage.hiddenCls);
    $(emailInpout).removeClass('ph-email_err_border');
    $('.ph-usernamelabel ').removeClass('ph-email_err_txt');
    $('.ph-exclamation-mark').hide();

    if (ACC.validation.email(emailValue)) {
      $('.ph-email_error').removeClass(ACC.registerPage.hiddenCls);
      $(emailInpout).addClass('ph-email_err_border');
      $('.ph-usernamelabel ').addClass('ph-email_err_txt');
      $('.ph-exclamation-mark').show();

      return false;
    } else if (emailValue === '') {
      $('.feedback').show();

      return false;
    }

    return true;
  }

  $(document).on('keyup', '.ph-reset_email_input', function(event) {
    event.stopPropagation();
    validateResetEmailAddress();
  });

  $(document).on('click', '.ph-send__link ', function(event) {
    event.stopPropagation();

    if (validateResetEmailAddress()) {
      $('#forgottenPwdForm').submit();
    }
  });

  $(document).on('keyup change', '.ph-reset_email_input', function() {
    /* Commenting below statements to keep the email address field in sync with login page - US 3670646
    $('.feedback').hide();
    $('.ph-email_error').addClass(ACC.registerPage.hiddenCls);
    $('.ph-reset_email_input').removeClass('ph-email_err_border');
    $('.ph-usernamelabel ').removeClass('ph-email_err_txt');
    $('.ph-exclamation-mark').hide();
    */
  });
});

$(window).on('load', function() {
  if ($('.ph-Login__bannerimg').length === 0) {
    $('.ph-image-sectionNew').addClass('ph-removeheight');
    $('.ph-newlogin').addClass('ph-removepos');
  }
});

ACC.registerPage = {
  errorClass: 'form_field_error ph-form_field_error',
  hiddenCls: 'hidden',
  accountNumberId: 'ph-commnumber',
  signUpErr: 'ph-signup__error',
  emptyVal: 'ph-register__emptyvalue',
  emptyContent: 'data-emptyContent',
  isEmptyValue: function(inputId) {
    var errormsgValue = $('#' + inputId).attr(ACC.registerPage.emptyContent),
        inputValue = '';

    if ($('#' + inputId).find('.form_field-input').has('input')) {
      inputValue = $('#' + inputId).find('input').val();
    } else if ($('#' + inputId).find('.form_field-input').has('select')) {
      inputValue = $('#' + inputId).find('option:selected').val();
    }

    if (inputValue === '' || inputValue === null || inputValue === 'undefined') {
      $('#' + inputId).find('.' + ACC.registerPage.signUpErr).addClass(ACC.registerPage.errorClass);
      $('#' + inputId).find('.' + ACC.registerPage.emptyVal).text(errormsgValue);
    } else {
      $('#' + inputId).find('.' + ACC.registerPage.signUpErr).removeClass(ACC.registerPage.errorClass);
      $('#' + inputId).find('.' + ACC.registerPage.emptyVal).text('');
    }
  },
  validateFields: function(inputIdName) {
    var selectedOption = $('input[name="philipsAccountNumber"]:checked').val();

    if (selectedOption === 'false' && inputIdName === ACC.registerPage.accountNumberId) {
      ACC.registerPage.isEmptyValue('invalid');
    } else if (selectedOption === 'true' && inputIdName === ACC.registerPage.accountNumberId) {
      ACC.registerPage.validateAccountNumber();
    } else {
      ACC.registerPage.isEmptyValue(inputIdName);
    }
  },
  validateAccountNumber: function() {
    var custAccNumber = $('input[name="custAccountNumber"]').val(),
        errormsgValue = $('#' + ACC.registerPage.accountNumberId).attr(ACC.registerPage.emptyContent),
        isValid = true;

    isValid = ACC.validation.customerAccountNumber(custAccNumber);

    if (isValid === true) {
      $('#' + ACC.registerPage.accountNumberId).find('.' + ACC.registerPage.signUpErr).addClass(ACC.registerPage.errorClass);
      $('#' + ACC.registerPage.accountNumberId).find('.' + ACC.registerPage.emptyVal).text(errormsgValue);
    } else {
      $('#' + ACC.registerPage.accountNumberId).find('.' + ACC.registerPage.signUpErr).removeClass(ACC.registerPage.errorClass);
      $('#' + ACC.registerPage.accountNumberId).find('.' + ACC.registerPage.emptyVal).text('');
    }
  }
};

/* eslint-disable  security/detect-unsafe-regex */
ACC.validation = {
  email: function(value) {
    var ckEmail = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if (ckEmail.test(value)) {
      return false;
    }

    return true;
  },
  customerAccountNumber: function(accountNumber) {
    var numberRegex = /^\d{9,10}$/;

    if (numberRegex.test(accountNumber)) {
      return false;
    }

    return true;
  }
};
/* eslint-enable  security/detect-unsafe-regex */
$(document).ready(function() {
  if ($('.pageLabel-accountRegisterPage').length > 0) {
    $(document).on('click', '.ph-registration__btn', function(event) {
      var lastnameInputId = '';

      event.stopPropagation();

      $('.ph-interstitial-loader').removeClass('hidden');
      $(' .ph-nonorgtype input[type="text"]').each(function() {
        if ($(this).val() === '') {
          lastnameInputId = $(this).attr('id');
          ACC.registerPage.validateFields(lastnameInputId);
        }
      });

      if ($('.ph-form_field_error').length > 0) {
        $('.ph-interstitial-loader').addClass('hidden');

        return false;
      }

      $('#userRegistrationForm').submit();

      return true;
    });

    $(document).on('change', '#philipsAccountNumber', function() {
      var selectedOption = $('input[name="philipsAccountNumber"]:checked').val();

      if (selectedOption === 'true') {
        $('.ph-commercenumber').removeClass(ACC.registerPage.hiddenCls);
        $('#ph-custAccountNumber').removeClass(ACC.registerPage.hiddenCls);
      } else {
        $('.ph-commercenumber').addClass(ACC.registerPage.hiddenCls);
        $('#ph-custAccountNumber').addClass(ACC.registerPage.hiddenCls);
        $('#' + ACC.registerPage.accountNumberId).find('.' + ACC.registerPage.signUpErr).removeClass(ACC.registerPage.errorClass);
        $('#' + ACC.registerPage.accountNumberId).find('.' + ACC.registerPage.emptyVal).text('');
        $('input[name="custAccountNumber"]').val('');
      }
    });
  }
});
